const IndividualApproachIcon = ({ className, onClick, width = 16, height = 16 }) => (
  <svg
    width={width}
    className={className}
    onClick={onClick}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.5" cy="22" r="20" fill="#CEFBFA" />
    <rect x="17" y="5" width="24" height="20" rx="4" fill="#fff" />
    <path
      d="M24.667 25c-3.82 10-14.514 0-18.334 10m22.5-10h2.503c3.928 0 5.892 0 7.112-1.22 1.22-1.22 1.22-3.185 1.22-7.113v-3.334c0-3.928 0-5.892-1.22-7.113C37.228 5 35.264 5 31.335 5H24.67c-3.928 0-5.893 0-7.113 1.22-1.034 1.034-1.192 2.602-1.216 5.447"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="15.5"
      cy="20.833"
      fill="#fff"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      r="4.167"
    />
    <path
      opacity=".4"
      d="M23 11.667h10m0 6.666h-5"
      stroke="#000"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IndividualApproachIcon;
